import { render, staticRenderFns } from "./LoadKey.vue?vue&type=template&id=05b477cb&scoped=true&"
import script from "./LoadKey.vue?vue&type=script&lang=ts&"
export * from "./LoadKey.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b477cb",
  null
  
)

export default component.exports